import * as React from 'react'
import {Button as B} from "@material-ui/core";

export const Button = ({variant, style, size, ...props}: any) => {

  return <B {...props} style={{marginLeft: 10, ...style}} variant={variant || 'contained'} size={size || 'small'}/>
};